import './App.css';
import DriveConnector from './Pages/DriveConnector/DriveConnector';
import { Typography } from '@mui/material';

function App() {
  return (
    <div className="App">
        <Typography variant="h6" style={{ flexGrow: 1 }}>
            <DriveConnector />
        </Typography>
    </div>
  );
}

export default App;
